export const VerificationStatus_NoStatus       = 0
export const VerifiactionStatus_Verified       = 1
export const VerificationStatus_OnVerification = 2
export const VerificationStatus_Declined       = 3